export default {
  root: {
    boxShadow: '0px 2px 20px 0px #00000014',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    alignSelf: 'flex-end',
  },
  title: {
    lineHeight: '28px',
    fontWeight: '500',
    px: 4,
    mb: 1,
  },
  body: {
    px: 4,
    pb: 4,
    fontSize: '16px',
    lineHeight: '24px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
    p: 4,
    pt: 2,
    '& .MuiButtonBase-root': {
      minWidth: 200,
    },
  },
};
